// The thread: which room the visitor last stood in on the home, kept for the tab's session.
// Reopening the home in the same session resumes the walk there, once per page load.
const KEY = "pp_thread_v1";
let resumed = false;

export const rememberRoom = (room) => {
  try { sessionStorage.setItem(KEY, room); } catch { /* private mode — the walk simply starts at the threshold */ }
};

export const threadRoom = () => {
  try { return sessionStorage.getItem(KEY); } catch { return null; }
};

export function resumePending(pathname, hash) {
  if (resumed || pathname !== "/" || hash) return null;
  const room = threadRoom();
  return room && room !== "prismpixel" ? room : null;
}

export const markResumed = () => { resumed = true; };
